<template>
<div class="event-handling-container">
  <!-- 标题区域 - 单独一行 -->
  <div class="event-title" v-if="activeIndex == 1">
    通知记录
  </div>
  <div class="event-title" v-if="activeIndex == 2">
    紧急通知
  </div>
  <div class="event-list">
    
    <div class="event-list-container" ref="eventListContainer">
      <!-- 标题 -->
      <div style="display: flex;align-items: center;" @click="navBack">
          <img :src="$staticUrl('/statics/2025/09/13/return_20250913141253A062.png')" alt="" style="width: 14px;height: 14px;vertical-align: bottom;"></img>
          <div style="color: #fff; margin-left: 5px;font-size: 15px;">返回</div>
      </div>

      <!-- 事件列表 -->
      <div class="event-items">
        <!-- 处理中事件 -->
        <!-- 使用ref替代ID，更安全的获取方式 -->
        <div class="scroll-container">
            <div class="title">{{info.noticeTitle}}</div>
            <div style="margin-top: 30px;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid #1E524F; padding-bottom: 10px;">
              <div style="display: flex;align-items: center;">
                <img :src="$staticUrl('/statics/2025/11/03/notice_type_20251103100538A286.png')" alt="" style="width: 14px;height: 14px;vertical-align: bottom;">
                <div style="font-size: 14px;color: #ccc;margin-left: 5px;">通知类型：</div>
                <div style="font-size: 14px;color: #fff;">{{ info.noticeTypeName }}</div>
                <div style="font-size: 12px;color: #FF3A3A;background: #A01A1A;border-radius: 4px;padding: 1px 6px;margin-left: 5px;" v-if="info.emergencyStatus == 1">紧急</div>
              </div>
              <div style="display: flex;align-items: center;">
                <img :src="$staticUrl('/statics/2025/11/03/notice_time_20251103100640A287.png')" alt="" style="width: 14px;height: 14px;vertical-align: bottom;">
                <div style="font-size: 14px;color: #ccc;margin-left: 5px;">通知时间：</div>
                <div style="font-size: 14px;color: #fff;">{{info.createTime}}</div>
              </div>
              <div style="display: flex;align-items: center;">
                <img :src="$staticUrl('/statics/2025/11/03/notice_estate_20251103100702A288.png')" alt="" style="width: 18px;height: 14px;vertical-align: bottom;">
                <div style="font-size: 14px;color: #ccc;margin-left: 5px;">通知物业：</div>
                <div style="font-size: 14px;color: #fff;max-width: 300px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{info.estateList.map(item => item.estateName).join(',') }}</div>
              </div>
            </div>
            <div style="margin-top: 15px;border-bottom: 1px solid #1E524F; padding-bottom: 10px;flex:1;">
              <div class="scroll-wrapper" ref="scrollWrapper">
                <ul 
                    v-infinite-scroll="load" 
                    infinite-scroll-disabled="loading"
                    infinite-scroll-distance="10"
                    infinite-scroll-container="this.$refs.scrollWrapper"
                    style="padding: 0px;margin: 0px;"
                    class="infinite-list"
                    ref="infiniteList"
                >
                    <li v-html="info.noticeContent"></li>
                </ul>
              </div>
            </div>
            <div style="display: flex;margin-top: 20px;">
              <div style="display: flex; background: linear-gradient( 360deg, #06585A 0%, rgba(0,59,61,0.3) 100%);padding: 10px;margin-right: 10px;border-radius: 10px;" v-for="item in info.url.split(',')" :key="item">
                <img src="@/assets/file.png" alt="" style="width: 80px;height: 80px;vertical-align: bottom;">
                <div style="display: flex;flex-direction: column; margin-left: 10px;">
                  <div style="font-size: 14px;color: #fff; width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.split('/').pop() }}</div>
                  <div style="margin-top: auto;display: flex;align-items: center;justify-content: end;" @click="onDownload(item)">
                    <i class="el-icon-download" style="color: #0EE0D4;"></i>
                    <div style="font-size: 14px;color: #0EE0D4;">下载</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {noticeDetail} from "@/api/notice";
export default {
  name: 'info',
  props: {
    activeIndex: {
      type: Number,
      default: 1
    },
    notice_id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: '通知记录',
      info: null
    }
  },
  mounted() {
    this.$on('onDetail',(id)=>{
      console.log(id);
    })
    // 确保DOM完全渲染后再执行
    this.$nextTick(() => {
        // 安全检查：先确认元素存在
        if (this.$refs.scrollWrapper && this.$refs.infiniteList) {
            // 绑定滚动事件
            this.$refs.scrollWrapper.addEventListener('scroll', this.handleManualScroll);
            // 检查初始内容
            this.ensureEnoughContent();
        } else if (!this._isDestroyed) {
            // console.warn('滚动容器或列表元素未找到，可能被条件渲染隐藏');
            // 重试机制：100ms后再次尝试
            setTimeout(() => {
              if (!this._isDestroyed) this.mounted();
            }, 100);
        }
    });
  },
  created() {
    setTimeout(() => {
      if (!this._isDestroyed) this.noticeDetail()
    }, 500);
  },
  beforeDestroy() {
      // 移除事件前先检查元素是否存在
      if (this.$refs.scrollWrapper) {
          this.$refs.scrollWrapper.removeEventListener('scroll', this.handleManualScroll);
      }
  },
  methods: {
    onDownload(item) {
      window.open(item, '_blank')
    },
    noticeDetail() {
      noticeDetail({id:this.notice_id}).then(res => {
        this.info = res.data;
      })
    },
    ensureEnoughContent() {
        // 双重安全检查
        if (!this.$refs.scrollWrapper || !this.$refs.infiniteList) return;
        
        const container = this.$refs.scrollWrapper;
        const list = this.$refs.infiniteList;
        
        // 确保容器和列表的高度都有效
        if (container.clientHeight && list.clientHeight && list.clientHeight <= container.clientHeight) {
            // this.load();
        }
    },
    load() {
        console.log('加载中...');
        if (this.loading) return;
        
        this.loading = true;
        
        this.$emit('load');
    },
    handleManualScroll() {
        if (!this.$refs.scrollWrapper) return;
        
        const container = this.$refs.scrollWrapper;
        const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        console.log('scrollBottom', scrollBottom == 0);
        if (scrollBottom == 0) {
            this.load();
        }
    },
    navBack() {
      this.$emit('onBack');
    }
  }
}
</script>

<style scoped>
.event-handling-container {
  display: flex;
  flex-direction: column; /* 垂直排列：标题 + 内容 */
  width: 1530px;
  height: 880px;
  background-color: rgba(51,142,134,0.16);
  border-radius: 4px;
  overflow: hidden;
}

/* 标题样式 - 渐变背景 */
.event-title {
  width: 320px;
  padding: 10px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background-image: linear-gradient(135deg, #016565, #0a2442);
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0; /* 防止被压缩 */
}

.scroll-wrapper {
    width: 1430px;
    height: 460px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;

}

.scroll-container {
    flex:1;
    display: flex;
    flex-direction: column;
    background-color: rgba(18, 59, 55, 0.3);
    padding: 15px;
}

.infinite-list-item {
    margin-top: 15px;
    margin-right: 10px;
}

.event-list {
  display: flex;
  flex-direction: column;
  margin: 15px;
  flex:1;
  /* align-items: center; */
}

.event-list-container {
  display: flex;
  flex-direction: column;
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-items {
  display: flex;
  flex-direction: column;
  flex:1;
  margin-top: 10px;
}

.title {
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

</style>
